import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import WorksheetCard from '../WorksheetCard';
import { supabase } from '../supabaseClient';
import { toast } from 'react-toastify';
import mirrorimage from '../mirrorimage.webp';

function Accomplishments({ goBack, goHome }) {

    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                toast.error('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'accomplishments',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                toast.error('Failed to save progress: ' + progressError.message);
                return;
            }
            toast.success('Session progress has been saved successfully!');
        } catch (err) {
            toast.error('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Accomplishments
            </h3>

            {/* Top Card with Image, Title, and Subtitle */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    overflow: 'hidden',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    textAlign: 'center',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        padding: '24px',
                        background: 'rgba(255,255,255,0.85)',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    <h2
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Accomplishments
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: 0,
                        }}
                    >
                        Celebrating your progress and wins, big or small, builds confidence and momentum.
                    </p>
                </div>
            </div>


            {/* Session Helper Cards Row */}
            <div
                className="accomplishments-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        • We get to define what an accomplishment is for us.<br />
                        • Our worthiness of love and appreciation is seperate from our accomplishments.<br />
                        • It can be scary to be recognized for what we have accomplished, or not recognize for what we have accomplished.<br />
                        • Reflect on how staying in your comfort zone can limit growth.<br />
                        • Sometimes we have to learn new skills in order to accomplish our goals.<br />
                        • Accomplishment is always happening on a lot of levels.
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        1. What is something you have accomplished that makes you feel honorable?<br />
                        2. Is there something you are currently working to accomplish in your life?<br />
                        3. Do you generally aim for accomplishments that will be recognized by someone else?<br />
                        4. How do you react when you feel challenged while trying to accomplish something?<br />
                        5. Do you know your worth seperately from what you have accomplished?<br />
                        6. What is something you want to make sure you accomplish before your time on earth is done?
                    </div>
                </div>
            </div>

            {/* WorksheetCard Section */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
                marginBottom: '24px',
            }}>
                <WorksheetCard title="Accomplishments Worksheet" columnName="accomplishments" />
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        The worksheet above is provided for you to take some time and list your accomplishments.  Big or small, these are things you know you have accomplished.  It is important to be aware of our own power to manage our lives and this activity is meant to help strengthen that for you. The worksheet can be edited at any time and the information will be carried over to your Know Thyself page.  There are so many aspects of you and your accomplishments are worth noting! You may want to add what efforts and skills went into acheving your accomplishments as well as lessons you may have learned along the way. 
                    </p>
                </div>

                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        If you have trouble compiling your list of accomplishments it may help to look at what others have recognized you for. What compliments have you received? What promotions or awards have you been given? Sometimes we may find ourselves surrounded by people who do not recognize us, and this can be our habit too.  It is ok to start small when we are looking at our accomplishments.  I ate fruit today, I brushed my teeth, I smiled at a stranger...   Whatever feels like an accomplishment to you counts.  It really is your own standards you are trying to meet. Sometimes it can feel like life is pushing us to grow.  Fear can come up around accomplishments and to offset that fear we might cling to coping by staying in a "comfort zone".  The comfort zone is where dreams go to die... Is that a meme I read somewhere?
<br />
Here is something I know the comfort zone is good for, and that is a place where humans feel safe.   Anytime we want to heal ourselves that healing is done in a nice safe space like a comfort zone.  <br />
We need it.
 We need to know there is a space where we won't be pushed to grow past our comfort, where we know what to expect, where we have mastered regulating ourselves in the midst of. We need to feel accomplished and comfortable sometimes. <br />

It is not bad to have comfort zones.  We just have to make sure we have the bravery needed to leave them when we know they are holding us back.

                    </p>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Reflect on your past accomplishments and the effort behind them. Celebrate your accomplishments to boost confidence and motivation.
Do you think recognizing your accomplishments can inspire future success?
                    </p>
                </div>
            </div>

            {/* Navigation Buttons */}
            <div
                className="accomplishments-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                }}
            >
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goBack}>Back</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={goHome}>Home</button>
                <button style={{
                    backgroundImage: `url(${buttonImage})`,
                    backgroundSize: 'cover',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '10px 20px',
                    width: '120px',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }} onClick={handleSaveProgress}>Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .accomplishments-nav-btn-row {
                        /* Remove sticky/fixed positioning for mobile, just keep as a row */
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-bottom: 16px;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Accomplishments;